import qs from 'qs';
import client from '@/api/base';

export default {
  async getInvoiceDetail() {
    const response = await client.get('coaching/coach/invoice-details/');
    return response;
  },

  async postInvoiceDetail(data) {
    const response = await client.post('coaching/coach/invoice-details/', data);
    return response;
  },

  async patchInvoiceDetail(data) {
    const response = await client.patch('coaching/coach/invoice-details/', data);
    return response;
  },

  // Coach's list
  async getCoachInvoices(params) {
    const response = await client.get(`coaching/coach/invoice/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getOneCoachInvoice(id) {
    const response = await client.get(`coaching/coach/invoice/${id}/`);
    return response;
  },

  async patchCoachInvoice(id, data) {
    const response = await client.patch(`coaching/coach/invoice/${id}/`, data);
    return response;
  },

  async confirmCoachInvoices(id) {
    const response = await client.patch(`coaching/coach/invoice/${id}/confirm/`);
    return response;
  },

  async getCoachInvoiceDetail(id) {
    const response = await client.get(`coaching/coach/invoice/${id}/report/`);
    return response;
  },

  async getCoachInvoiceDetailMAM(id) {
    const response = await client.get(`coaching/coaches/invoice/out/${id}/report/`);
    return response;
  },

  async importInvoiceDetail() {
    const response = await client.post('coaching/coach/invoice-details/sync/');
    return response;
  },
};
